export default class LoadMoreHandler {
    static instances = new Map()

    constructor(pagination) {
        this.pagination = pagination
        this.container = pagination.querySelector(".notes-container")
        this.button = pagination.querySelector(".load-more")
        this.pagination = pagination.querySelector(".pagination-container")
        this.paginationInfo = pagination.querySelector(".pagination-info")
        this.category = pagination.dataset.category
        this.currentPage = parseInt(pagination.dataset.currentPage)
        this.totalPages = parseInt(pagination.dataset.totalPages)
        this.perPage = parseInt(pagination.dataset.perPage) || 3
        this.sectionId = `section-${this.category ? this.category.toLowerCase() : 'unknown'}`
        
        // Registrar la instancia solo si category existe
        if (this.category) {
            LoadMoreHandler.instances.set(this.category, this)
        }
        
        this.init()
    }

    static getInstance(category) {
        return LoadMoreHandler.instances.get(category)
    }

    init() {
        if (!this.button) return
        this.button.addEventListener('click', (e) => {
            e.preventDefault()
            this.handleLoadMore()
        })
    }

    isTag() {
        // Detectar si estamos en una página de tag verificando la URL
        return window.location.pathname.startsWith('/tag/')
    }

    handleLoadMore() {
        if (!this.button) return
        this.button.disabled = true
        this.fetchMoreContent()
    }

    fetchMoreContent() {
        // Construir la URL basada en si es categoría o tag
        let url
        if (this.isTag()) {
            url = `/load-more?tag=${this.category}&page=${this.currentPage + 1}&per_page=${this.perPage}`
        } else {
            url = `/load-more?category=${this.category}&page=${this.currentPage + 1}&per_page=${this.perPage}`
        }
        
        fetch(url, {
            method: 'GET'
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }
            return response.text()
        })
        .then(html => {
            // Extraer el contenido de #load-content y actualizar paginación
            const extractedContent = this.extractLoadContent(html)
            if (extractedContent) {
                this.insertContent(extractedContent)
                // La paginación se actualiza automáticamente en extractLoadContent
            } else {
                throw new Error('No content found in #load-content')
            }
        })
        .catch(error => {
            console.error('Error loading more content:', error)
            this.restoreButton()
        })
    }

    extractLoadContent(html) {
        // Crear un elemento temporal para parsear el HTML
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = html
        
        // Buscar el elemento #load-content
        const loadContent = tempDiv.querySelector('#load-content')
        
        if (loadContent) {
            // Extraer información de paginación
            this.extractPaginationInfo(tempDiv)
            
            // Extraer y actualizar el contenido de paginación
            this.extractAndUpdatePaginationContent(tempDiv)
            
            return loadContent.innerHTML
        }
        
        return null
    }

    extractAndUpdatePaginationContent(tempDiv) {
        // Buscar el elemento #pagination en la respuesta
        const paginationContent = tempDiv.querySelector('#pagination')
        
        if (paginationContent && this.pagination) {
            // Actualizar el contenido del contenedor de paginación
            this.pagination.innerHTML = paginationContent.innerHTML
        }
    }

    extractPaginationInfo(tempDiv) {
        // Buscar el elemento de paginación
        const pagination = tempDiv.querySelector('.pagination')
        
        if (pagination) {
            // Verificar si hay un enlace "next" activo
            const nextLink = pagination.querySelector('a.next_page')
            const hasNextPage = nextLink && !nextLink.classList.contains('disabled')
            
            // Extraer información de la página actual
            const currentPageElement = pagination.querySelector('.current')
            const currentPage = currentPageElement ? parseInt(currentPageElement.textContent) : this.currentPage
            
            // Extraer información de páginas totales disponibles
            const allPageLinks = pagination.querySelectorAll('a, .current')
            let totalPages = this.totalPages // Mantener el valor anterior si no se puede determinar
            
            // Buscar el número de página más alto
            allPageLinks.forEach(link => {
                const pageText = link.textContent.trim()
                const pageNum = parseInt(pageText)
                if (!isNaN(pageNum) && pageNum > totalPages) {
                    totalPages = pageNum
                }
            })
            
            // Si no hay enlace "next", probablemente estamos en la última página
            if (!hasNextPage && currentPage > 0) {
                totalPages = currentPage
            }
            
            // Actualizar el estado de paginación (sin nextPageUrl)
            this.updatePaginationFromWillPaginate(currentPage, totalPages, hasNextPage)
        }
    }

    updatePaginationFromWillPaginate(currentPage, totalPages, hasNextPage) {
        // Actualizar la página actual
        this.currentPage = currentPage
        this.totalPages = totalPages
        
        // Actualizar el dataset del botón
        this.button.dataset.currentPage = this.currentPage
        this.button.dataset.totalPages = this.totalPages
        
        // Actualizar el estado del botón
        if (hasNextPage) {
            this.button.disabled = false
        } else {
            this.button.style.display = 'none'
        }
    }

    updatePaginationState() {
        // Este método ya no es necesario, se reemplaza por updatePaginationFromWillPaginate
        // Mantenido por compatibilidad
        this.button.disabled = false
    }

    restoreButton() {
        if (!this.button) return
        this.button.disabled = false
    }

    insertContent(html) {
        if (!this.container) return
        this.container.insertAdjacentHTML('beforeend', html)
        // Notificar que se han insertado nuevos elementos para que Blazy revalide
        const event = new CustomEvent('loadMore:inserted', {
            detail: {
                container: this.container,
                category: this.category
            }
        })
        document.dispatchEvent(event)
    }
}
